import { generateAiEffectBlocksFromResult } from './generateAiEffectBlocksFromResult';
/**
 * Generate code that can be executed to preview the output of the AI-generated blocks.
 */
export var generatePreviewCode = function (workspace, effect) {
    var _a, _b;
    var blocks = generateAiEffectBlocksFromResult(workspace, effect);
    // Create a temporary setup block
    var setup = workspace.newBlock('Dancelab_whenSetup');
    // Attach the blocks to the setup block
    (_b = (_a = setup.getInput('DO')) === null || _a === void 0 ? void 0 : _a.connection) === null || _b === void 0 ? void 0 : _b.connect(blocks[0].previousConnection);
    if (!Blockly.getGenerator().isInitialized) {
        Blockly.getGenerator().init(workspace);
    }
    return Blockly.getGenerator().blockToCode(setup);
};
